import { Link, Outlet, useLoaderData, useLocation, useSearchParams } from "react-router-dom";

import ServerFooter from "../common/ServerFooter";
import UserInfo from "src/components/common/userInfo";
import type { Assignment, AssignmentListResponse } from "./types";
export const extraFields = ["page", "limit"];
export default function Assignments() {
    const [searchParams] = useSearchParams();
    const { assignments, total } = useLoaderData() as AssignmentListResponse;
    const location = useLocation();
    const onFilter = [...searchParams.keys()].some(key => !extraFields.includes(key));

    return (
        <div className={"cssContent" + (total > 0 ? " pb8rem" : "")}>
            <div className="mt-2">
                <Link
                    className="btn btn-outline-primary position-relative"
                    to={{ pathname: "Filter", search: location.search }}
                    replace
                >
                    Filter
                    {onFilter ? (
                        <span
                            children="on"
                            className="badge text-bg-primary position-absolute top-0 start-100 translate-middle"
                            style={{ minWidth: "2.4em" }}
                        />
                    ) : null}
                </Link>
                <Link
                    children="Export"
                    className="btn btn-outline-primary ms-3"
                    to={{ pathname: "Export", search: location.search }}
                />
                <Link
                    children="Add"
                    className="btn btn-outline-primary float-end"
                    to={{ pathname: "Add", search: searchParams.get("workId") ? `?workId=${searchParams.get("workId")}` : "" }}
                />
            </div>
            {!assignments.length ? (
                <div className="cssLoading">Empty</div>
            ) : (
                <div className="table-responsive">
                    <table className="table">
                        <thead className="noTableTopBorder">
                            <tr>
                                <th>Work</th>
                                <th>Project</th>
                                <th>Category</th>
                                <th>Location</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Technician</th>
                                <th>Supervisor</th>
                                <th>JSA Initiator</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {assignments.map((assignment: Assignment) => (
                                <tr key={assignment.id}>
                                    <td>
                                        {assignment.workId ? (
                                            <Link to={`/Works/${assignment.workId}`}>{assignment.workName || assignment.workId}</Link>
                                        ) : (
                                            assignment.workName
                                        )}
                                    </td>
                                    <td>
                                        {assignment.projectId ? (
                                            <Link to={`/Projects/${assignment.projectId}`}>{assignment.projectName}</Link>
                                        ) : (
                                            assignment.projectName
                                        )}
                                    </td>
                                    <td>{assignment.laborCategory}</td>
                                    <td>
                                        {assignment.workLocation ? (
                                            <a
                                                href={assignment.workCoords ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(assignment.workCoords)}` : undefined}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {assignment.workLocation}
                                            </a>
                                        ) : null}
                                    </td>
                                    <td>{assignment.startTime}</td>
                                    <td>{assignment.endTime}</td>
                                    <td><UserInfo id={assignment.userId} name={assignment.userName} /></td>
                                    <td><UserInfo id={assignment.supervisorId} name={assignment.supervisorName} /></td>
                                    <td><UserInfo id={assignment.leadId} name={assignment.leadName} /></td>
                                    <td>
                                        <Link children="Detail" className="btn btn-outline-primary" to={String(assignment.id)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {total > 0 ? <ServerFooter length={total} /> : null}
            <Outlet />
        </div>
    );
}
